<template>
  <div
    id="product-spesification"
    uk-scrollspy="cls: uk-animation-fade; target: .uk-section; delay: 500; repeat: false;"
  >
    <div class="uk-section" uk-scrollspy-class="uk-animation-slide-bottom">
      <div class="uk-container">
        <div
          class="uk-flex uk-flex-middle uk-grid-collapse"
          uk-grid
          id="top-section"
        >
          <div class="uk-width-1-2@s" id="product-features">
            <h3 class="uk-text-uppercase">{{ productName }}</h3>

            <div class="uk-column-1-2@s">
              <p class="uk-text-uppercase">{{ description.replace( /(([^>]+)>)/ig, ' ') }}</p>
              <ul>
                <li v-for="feature in features" :key="feature">
                  {{ feature }}
                </li>
              </ul>

              <p class="uk-margin-remove price">{{ price }}</p>
              <!-- <router-link :to="link" class="uk-button uk-button-primary uk-margin-small-top uk-text-truncate">BUY NOW</router-link> -->
            </div>
          </div>
          <div
            class="uk-width-1-2@s uk-height-1-1 uk-margin-auto-bottom uk-flex uk-flex-middle"
            id="trapezoid"
          >
            <figure
              :style="{
                marginTop: `${imgPositionY}px`,
                marginBottom: `-${imgPositionY}px`,
              }"
            >
              <img
                :src="img"
                :alt="img"
                uk-img
                :style="{
                  transform: `${imgScale}`,
                  transformOrigin: `${imgPositionX}`,
                }"
              />
            </figure>
          </div>
        </div>

        <div class="uk-flex uk-flex-center uk-margin-top">
          <button
            class="uk-button uk-button-primary"
            style="border-radius: 10px"
            @click="buyNow()"
          >
            Buy Now
          </button>
        </div>

        <div
          class="uk-flex uk-flex-middle uk-grid-collapse uk-margin-large-top"
          uk-grid
          id="spesification"
        >
          <div class="uk-width-1-1">
            <h3 class="uk-text-uppercase">SPECIFICATIONS</h3>

            <!-- <dl class="uk-column-1-2@s uk-column-1-3@m uk-column-1-4@l">
                            <div v-for="spec in spesification" :key="spec.title" class="spec" style="margin-bottom: 10px;">
                                <dt class="uk-text-small">{{ spec.title }}</dt>
                                <dd v-if="Array.isArray(spec.subtitle)">
                                    <p v-for="subtitle in spec.subtitle" :key="subtitle" class="uk-text-small uk-margin-remove">{{ subtitle }}</p>
                                </dd>
                                
                                <dd v-else><p class="uk-text-small uk-margin-remove">{{ spec.subtitle }}</p></dd>
                            </div>
                        </dl> -->
            <div class="uk-flex" uk-grid>
              <div
                class="uk-width-1-5@m uk-width-1-2@s"
                v-for="(spec, i) in spesification"
                :key="i"
                style="margin-top: 15px"
              >
                <div class="uk-text-small">
                  <b>{{ spec.title }}</b>
                </div>
                <div
                  class="uk-text-small uk-margin-remove"
                  v-if="Array.isArray(spec.subtitle)"
                >
                  <p
                    v-for="(subtitle, j) in spec.subtitle"
                    :key="j"
                    class="uk-padding-remove"
                    style="margin: 0px"
                  >
                    {{ subtitle }}
                  </p>
                </div>
                <div class="uk-text-small uk-margin-remove" v-else>
                  <p class="uk-padding-remove" style="margin: 0px">
                    {{ spec.subtitle }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import $axios from "@/api.js";
import UIkit from "uikit";
export default {
  props: [
    "productName",
    "description",
    "features",
    "price",
    "link",
    "img",
    "imgScale",
    "imgPositionX",
    "imgPositionY",
    "spesification",
    "id",
  ],
  data() {
    return {
      product: this.productName,
    };
  },
  mounted() {
    // console.log(this.spesification)
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
  },
  methods: {
    ...mapActions("cart", ["getCarts"]),
    buyNow() {
      if (this.IS_AUTH) {
        $axios
          .post("cart/add_cart", {
            id_cust: this.GET_USER.id,
            prod_id: this.id,
            qty: 1,
          })
          .then((result) => {
            if (result.status == 200) {
              const data = result.data;
              if (data.status == "success") {
                  this.getCarts(this.GET_USER.id);
                  this.$router.push('/cart')
              } else {
                UIkit.notification({message: data.message, status: 'danger'})
              }
            } else {
              UIkit.notification({message: 'Something went wrong!', status: 'danger'})
            }
          })
          .catch((err) => {
            console.log(err.message);
            UIkit.notification({message: 'Something went wrong!', status: 'danger'})
          });
      } else {
        const modalLogin = document.querySelector("#modal-login");
        UIkit.modal(modalLogin).show();
      }
    },
  },
};
</script>

<style scoped>
#product-spesification .uk-section {
  padding-bottom: 80px;
}

#top-section {
  border: 1px solid rgb(67, 67, 68);
  border-radius: 10px;
  height: 380px;
}

#product-features {
  padding: 40px 20px 0 40px;
}

#product-features div {
  margin-top: 2vw;
}

#product-features h3 {
  margin-bottom: 0;
  font-size: 20px;
  letter-spacing: 0.3vw;
  color: rgb(95, 103, 105);
  line-height: normal;
}

#product-features p {
  color: rgb(194, 195, 197);
  letter-spacing: 2px;
  font-weight: 100;
  line-height: 1;
  font-size: 1.1vw;
  margin-bottom: 2.5vw;
}

p.price {
  color: #403f41;
}

#product-features ul {
  padding-left: 0;
  list-style-position: inside;
  margin-bottom: 3vw;
}

#product-features ul li {
  font-size: 0.8vw;
  margin-bottom: 15px;
}

#product-features a.uk-button {
  border-radius: 10px;
  font-size: 11px;
  letter-spacing: 1px;
}

#trapezoid {
  background: linear-gradient(
    to right top,
    rgb(242, 243, 244) 10%,
    rgb(221, 222, 224)
  );
  clip-path: polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%);
  border-radius: 0px 10px 10px 0px;
}

#trapezoid img {
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  /* width: 50%; */
}

@media screen and (max-width: 639px) {
  #top-section {
    height: auto;
    max-height: auto !important;
  }

  #product-features p {
    font-size: 14px;
  }

  #product-features ul li {
    font-size: 10px;
  }

  #trapezoid {
    clip-path: inset(0 0 0 0);
    border-radius: 0 0 10px 10px;
  }
}
</style>